import type { LabelModel } from 'api/inbox2'
import {
  ILabel,
  ILabelSeparatedByLevel,
} from 'Modules/Communication/shared/models/Labels'

export const getMappedLabels = (labels: LabelModel[]): ILabel[] =>
  labels.map(({ id, path, ...label }) => ({
    ...label,
    id,
    path,
    level: (path.match(/\//g) || []).length + 1,
  }))

// recursive function to create a list of labels from a flat structure
// Use depth-first-search to create children that startsWith same path as parent and has higher level
export const createLabelList = (
  labels: ILabel[],
  parent: ILabel = {
    id: '',
    path: '',
    level: 0,
  }
): ILabelSeparatedByLevel[] => {
  const children =
    labels?.filter(
      (label) =>
        label.path.startsWith(parent.path) && label.level > parent.level
    ) || []

  if (children.length > 0) {
    const childrens = children.filter((i) => i.level === parent.level + 1)

    return childrens.map((child) => {
      const childrenLabelList = createLabelList(children, child)

      return {
        ...child,
        children: childrenLabelList,
      }
    })
  }

  return []
}

// Gets the name of the path based on level
export const getPathFromLabelByLevel = (label: string, level: number) =>
  label.split('/')[level - 1]

export type NestedLabelOption = {
  value: string
  label: string
  children: NestedLabelOption[]
}

// Maps the createLabelList() tree into the shape snorre-v2 NestedDropdown expects
export const toNestedLabelOptions = (
  labels: ILabelSeparatedByLevel[]
): NestedLabelOption[] =>
  (labels ?? []).map((l) => ({
    value: l.id,
    label: getPathFromLabelByLevel(l.path, l.level),
    children: l.children?.length ? toNestedLabelOptions(l.children) : [],
  }))
